import Vue from 'vue';
import VueRouter from 'vue-router';

import accountPages from './account.p';
// import managerPages from './manager.p';
import mainPages from './main.p';
import userPages from './user.p';

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        // 如果你的連結是帶 # 這種
        // to.hash 就會有值(值就是連結)
        // 例如 #3
        if (to.hash) {
            return {
                // 這個是透過 to.hash 的值來找到對應的元素
                // 照你的 html 來看是不用多加處理這樣就可以了
                // 例如你按下 #3 的連結，就會變成 querySelector('#3')，自然會找到 id = 3 的元素
                selector: to.hash
            }
        }
    },
    routes: [ //路由匹配规则
        accountPages,
        mainPages,
        userPages,
        // 暂时注释Manager组件的路由注册。
        // managerPages,
        // Application
        {
            path: '/application/*.html',
            component: () => import(/* webpackChunkName: "Page-APPLICATION" */ '@/application/viewer.vue'),
            meta: {
                title: 'Application'
            },
        },
        // 404 Not found page
        {
            path: '*',
            component: () => import(/* webpackChunkName: "Page-NOTFOUND" */ '@/core/views/notFound.vue'),
            meta: {
                title: '啊哦，页面不见了'
            },
        }
    ],
})
export default router;